module.exports = __webpack_public_path__ + "static/img/g0R9.f802988.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video/g0R9.gif
// module id = hKny
// module chunks = 43